import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getWebStoryTemplates = createAsyncThunk("webStoryTemplates/getWebstoryTemplates", async (payload) => {
  try {
    const response = await magnifiAPI.getWebstoryTemplates(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteWebStoryTemplates = createAsyncThunk(
  "webStoryTemplates/deleteWebStoryTemplates",
  async (payload) => {
    try {
      const response = await magnifiAPI.deleteWebStoryTemplates(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const uploadStoryTemplate = createAsyncThunk("webStoryTemplates/uploadStoryTemplate", async (payload) => {
  try {
    const response = await magnifiAPI.uploadStoryTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const moveStoryTemplate = createAsyncThunk("webStoryTemplates/moveStoryTemplate", async (payload) => {
  try {
    const response = await magnifiAPI.moveStoryTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const testStoryTemplate = createAsyncThunk("webStoryTemplates/testStoryTemplate", async (payload) => {
  try {
    const response = await magnifiAPI.testStoryTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
